import React from 'react';
import { classes } from './start-root-box-section.st.css';
import { CommentsSort } from '../comments-sort/comments-sort';
export const StartRootBoxSectionSort = ({ selectedSort, hideSort }) => hideSort ? null : React.createElement(CommentsSort, { className: classes.sort, selectedSort: selectedSort });
//# sourceMappingURL=start-root-box-section-sort.js.map